import React, { useState, useEffect, Fragment } from 'react';
import Box from '../../Box';
import { ReactComponent as BackIcon } from '../../icons/back.svg';
import { ReactComponent as CallIcon } from '../../icons/call.svg';
import { ReactComponent as HangIcon } from '../../icons/hang.svg';
import { ReactComponent as MuteIcon } from '../../icons/mute.svg';
import { ReactComponent as UnmuteIcon } from '../../icons/unmute.svg';
import { ReactComponent as SearchIcon } from '../../icons/search.svg';

const ClientHeader = (props) => {

    const [zzzzzzz, setZzzzzzz] = useState(false);
    const [client, setClient] = useState(props.client);

    const [callStatus, setCallStatus] = useState('normal');
    const [softphone, setSoftphone] = useState({});
    const [muteStatus, setMuteStatus] = useState(false);
    const [showOtherPhoneNumbers, setShowOtherPhoneNumbers] = useState(false);
    const [otherPhoneNumbers, setOtherPhoneNumbers] = useState([]);

    const Popover = (props) => {
        if (props.show) {
            return <div className={'popover ' + props.position} style={{ width: props.width }}>{props.children}</div>
        } else {
            return null;
        }
    }

    useEffect(() => {
        //onload execute ....
        //setClient(props.client);
        //console.log('🐞DEBUG props.client.rut:', props.client.rut);
    }, []);

    return (
        <div className="flexRow headerClient">
            <div className="flexCol">
                <Box type="readOnly" className="" name="rut" label="Rut" value={client.rut}></Box>
                <Box type="readOnly" className="worb" name="phone" label="Teléfono" value={client.contacto.telefono1}></Box>
                <div className="callContainer">

                    <span className="wrapper rel">
                        {/* <a tooltip="Buscar más teléfonos" onClick={() => getOtherPhoneNumbers()}><SearchIcon /></a> */}
                        <a tooltip="Buscar más teléfonos" onClick={()=> console.log('TODO')}><SearchIcon /></a>

                        <Popover show={showOtherPhoneNumbers} position='bottom'>
                            <table>
                                <thead>
                                    <tr><th>Campaña</th><th>Teléfono</th><th></th></tr>
                                </thead>
                                <tbody>
                                    {otherPhoneNumbers.map((listValue, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{listValue.company_name}</td>
                                                <td className="nowrap">{listValue.campaign_name}</td>
                                                <td>{listValue.phone}</td>
                                                <td><a className="noTransform" onClick={() => softphone.sipCallPhone(listValue.phone)}><CallIcon /></a></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </Popover>
                    </span>


                    {(callStatus === 'normal' || callStatus === 'terminating' || callStatus === 'terminated') ? (
                        <a onClick={() => softphone.sipCallPhone(client.phone)}><CallIcon /></a>
                    ) :
                        <Fragment>
                            <a onClick={() => softphone.sipHangUp()}><HangIcon /></a>
                            <a onClick={() => { setMuteStatus(!muteStatus); softphone.sipToggleMute(); }}>{!muteStatus ? (<MuteIcon />) : <UnmuteIcon />}</a>
                        </Fragment>
                    }
                </div>
                <Box type="readOnly" className="x4" name="address" label="Direccion" value={client.direccion.full}></Box>
            </div>
        </div>
    );

}

export default ClientHeader;
